import React from "react";
import Navbar from "./components/Navbar";
import Home from "./views/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CategoryView from "./views/CategoryView";
import ProductView from "./views/ProductView";
import Cart from "./views/Cart";

function App() {
  return (
    <BrowserRouter>
      <div className="bg-white min-h-screen relative text-white flex flex-col gap-4 items-center">
        <Navbar />
        <Routes>
          <Route element={<Home />} index />
          <Route element={<CategoryView />} path="category/:title" />
          <Route element={<ProductView />} path="product/:title" />
          <Route element={<Cart />} path="cart" />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
